import { render, staticRenderFns } from "./widgetSecAttackerIpTopn.vue?vue&type=template&id=4a65b7b1&scoped=true&"
import script from "./widgetSecAttackerIpTopn.vue?vue&type=script&lang=js&"
export * from "./widgetSecAttackerIpTopn.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecAttackerIpTopn.vue?vue&type=style&index=0&id=4a65b7b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a65b7b1",
  null
  
)

export default component.exports